if (!customElements.get('gravix-price-slider')) {
  customElements.define(
    'gravix-price-slider',
    class GravixPriceSlider extends HTMLElement {
      connectedCallback() {
        this.minRange = this.querySelector('[data-gv2-price-min]');
        this.maxRange = this.querySelector('[data-gv2-price-max]');
        this.control = this.closest('.gv2-price-control');
        this.minField = this.control?.querySelector('input[name*=".gte"]');
        this.maxField = this.control?.querySelector('input[name*=".lte"]');

        if (!this.minRange || !this.maxRange || !this.minField || !this.maxField) return;

        this.minRange.addEventListener('input', (event) => this.onRangeInput(event, 'min'));
        this.maxRange.addEventListener('input', (event) => this.onRangeInput(event, 'max'));
        this.minRange.addEventListener('change', (event) => this.onRangeChange(event, 'min'));
        this.maxRange.addEventListener('change', (event) => this.onRangeChange(event, 'max'));
        this.minField.addEventListener('input', () => this.syncFromFields());
        this.maxField.addEventListener('input', () => this.syncFromFields());
        this.syncFromFields();
      }

      onRangeInput(event, handle) {
        event.stopPropagation();
        this.keepHandlesOrdered(handle);
        this.syncFields(false, handle);
        this.updateTrack();
      }

      onRangeChange(event, handle) {
        event.stopPropagation();
        this.keepHandlesOrdered(handle);
        this.syncFields(true, handle);
        this.updateTrack();
      }

      keepHandlesOrdered(handle) {
        const min = Number(this.minRange.value);
        const max = Number(this.maxRange.value);

        if (handle === 'min' && min > max) this.minRange.value = max;
        if (handle === 'max' && max < min) this.maxRange.value = min;
      }

      syncFields(submit, handle) {
        this.minField.value = Number(this.minRange.value) > 0 ? this.minRange.value : '';
        this.maxField.value =
          Number(this.maxRange.value) < Number(this.maxRange.max) ? this.maxRange.value : '';

        if (submit) {
          const changedField = handle === 'min' ? this.minField : this.maxField;
          changedField.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      syncFromFields() {
        const maximum = Number(this.maxRange.max);
        const min = this.parseField(this.minField.value, 0);
        const max = this.parseField(this.maxField.value, maximum);

        this.minRange.value = Math.min(min, max);
        this.maxRange.value = Math.max(min, max);
        this.updateTrack();
      }

      parseField(value, fallback) {
        if (!value) return fallback;
        const normalized = String(value).replace(/[^0-9.]/g, '');
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      updateTrack() {
        const maximum = Number(this.maxRange.max) || 1;
        const minPercent = (Number(this.minRange.value) / maximum) * 100;
        const maxPercent = (Number(this.maxRange.value) / maximum) * 100;
        this.style.setProperty('--gv2-price-min', `${minPercent}%`);
        this.style.setProperty('--gv2-price-max', `${maxPercent}%`);
      }
    }
  );
}
